import {isNil} from 'ramda';

import {VehicleStockOverviewResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export function getColumns(vehicleStockOverview: VehicleStockOverviewResponseBody | Nullish) {
  if (isNil(vehicleStockOverview)) {
    return [];
  }

  return [
    {
      label: i18n.t('page.homepage.vehicleWarehouse.labels.warehouseTotal'),
      tooltip: i18n.t('page.homepage.vehicleWarehouse.tooltips.warehouseTotal'),
      value: vehicleStockOverview.totalForSale,
      id: 'warehouseTotal',
    },
    {
      label: i18n.t('page.homepage.vehicleWarehouse.labels.inSale'),
      tooltip: i18n.t('page.homepage.vehicleWarehouse.tooltips.inSale'),
      value: vehicleStockOverview.selling,
      id: 'inSale',
    },
    {
      label: i18n.t('page.homepage.vehicleWarehouse.labels.inBuying'),
      tooltip: i18n.t('page.homepage.vehicleWarehouse.tooltips.inBuying'),
      value: vehicleStockOverview.buying,
      id: 'inBuying',
    },
  ] as const;
}
